export const INITIAL_COMPUTE_STATE = {
  loading: false,
  generation: 0,
};

export const PRICE_COMPUTE_STYLE_ID = "krs-price-compute";

export const PRICE_COMPUTE_CSS = `
[data-krs-compute="loading"] { position: relative; }
[data-krs-compute="loading"]::after {
  content: ""; position: absolute; top: 58%; left: 50%;
  width: 20px; height: 20px; margin: -10px 0 0 -10px;
  border: 2px solid currentColor; border-top-color: transparent;
  border-radius: 50%; animation: krs-spin .7s linear infinite;
  pointer-events: none;
}
@keyframes krs-spin { to { transform: rotate(360deg); } }
@media (prefers-reduced-motion: reduce) {
  [data-krs-compute="loading"]::after { animation: none; }
}
`;

export const beginCompute = (state = INITIAL_COMPUTE_STATE) => ({
  loading: true,
  generation: (state.generation || 0) + 1,
});

export const endCompute = (state = INITIAL_COMPUTE_STATE) => ({
  ...state,
  loading: false,
});

export const isVisibleComputeBusy = (state) =>
  Boolean(state && state.loading && state.generation > 1);

export const isPricedDataSlot = (slot) =>
  Boolean(
    slot &&
    slot.binding &&
    slot.binding.kind === "data" &&
    slot.binding.factors &&
    slot.binding.source,
  );

export const priceSlotHost = (element) => {
  if (!element) return null;
  return element.closest("button") || element;
};

const ensurePriceComputeStyle = (doc) => {
  if (!doc || doc.getElementById(PRICE_COMPUTE_STYLE_ID)) return;
  const style = doc.createElement("style");
  style.id = PRICE_COMPUTE_STYLE_ID;
  style.textContent = PRICE_COMPUTE_CSS;
  (doc.head || doc.body).appendChild(style);
};

export const applyPriceSlotLoading = (doc, slots, loading) => {
  if (!doc) return;
  ensurePriceComputeStyle(doc);
  for (const slot of slots || []) {
    if (!isPricedDataSlot(slot)) continue;
    const element = doc.querySelector("[data-kayros-slot='" + slot.id + "']");
    const host = priceSlotHost(element);
    if (!host) continue;
    if (loading) {
      host.setAttribute("data-krs-compute", "loading");
      host.setAttribute("aria-busy", "true");
    } else {
      if (host.getAttribute("data-krs-compute") === "loading") {
        host.removeAttribute("data-krs-compute");
      }
      host.removeAttribute("aria-busy");
    }
  }
};
